import React from 'react';
import SvgIcon from './SvgIcon';

const Alerts = props => {
    return (
        <SvgIcon viewBox="0 0 16 14" {...props}>
            <defs>
                <path
                    d="M36,181.6 L36,189.666667 C36,190.066667 35.7333333,190.333333 35.3333333,190.333333 L35.3333333,190.333333 L20.6666667,190.333333 C20.2666667,190.333333 20,190.066667 20,189.666667 L20,189.666667 L20,181.6 L27.0666667,185.4 C27.3333333,185.6 27.6666667,185.666667 28,185.666667 C28.3333333,185.666667 28.6666667,185.6 28.9333333,185.4 L28.9333333,185.4 L36,181.6 Z M35.3333333,177 C35.7333333,177 36,177.266667 36,177.666667 L36,177.666667 L36,179.666667 C36,179.933333 35.8666667,180.133333 35.6666667,180.266667 L35.6666667,180.266667 L28.3333333,184.266667 C28.2,184.333333 28.1333333,184.333333 28,184.333333 C27.8666667,184.333333 27.8,184.333333 27.6666667,184.266667 L27.6666667,184.266667 L20.3333333,180.266667 C20.1333333,180.133333 20,179.933333 20,179.666667 L20,179.666667 L20,177.666667 C20,177.266667 20.2666667,177 20.6666667,177 L20.6666667,177 Z"
                    id="path-1"
                ></path>
            </defs>
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Group-10" transform="translate(-20.000000, -177.000000)">
                    <mask id="mask-2" fill="white">
                        <use xlinkHref="#path-1"></use>
                    </mask>
                    <use id="Mask" fill="#FFFFFF" fillRule="nonzero" xlinkHref="#path-1"></use>
                </g>
            </g>
        </SvgIcon>
    );
};

Alerts.displayName = 'AlertsIcon';

export default Alerts;
